export function exportCSV(pools, filename = 'poolscope-export') {
  if (!pools || pools.length === 0) return;

  const headers = ['Name', 'Protocol', 'Chain', 'APR (%)', 'TVL ($)', 'Volume 24H ($)', 'Fees 24H ($)', 'Fee Tier', 'Risk', 'Stablecoin', 'Tokens'];
  const rows = pools.map(p => [
    p.name,
    p.protocol,
    p.chain,
    (p.apr || 0).toFixed(2),
    Math.round(p.tvl || 0),
    Math.round(p.volume24h || 0),
    Math.round(p.fees24h || 0),
    p.fee || '',
    p.risk || '',
    p.stablecoin ? 'Yes' : 'No',
    (p.tokens || []).join(' / '),
  ]);

  const csv = [
    headers.join(','),
    ...rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')),
  ].join('\n');

  downloadFile(csv, `${filename}.csv`, 'text/csv');
}

export function exportJSON(pools, filename = 'poolscope-export') {
  if (!pools || pools.length === 0) return;

  const data = pools.map(p => ({
    name: p.name,
    protocol: p.protocol,
    chain: p.chain,
    apr: p.apr,
    tvl: p.tvl,
    volume24h: p.volume24h,
    fees24h: p.fees24h,
    fee: p.fee,
    risk: p.risk,
    stablecoin: p.stablecoin,
    tokens: p.tokens,
  }));

  const json = JSON.stringify(data, null, 2);
  downloadFile(json, `${filename}.json`, 'application/json');
}

function downloadFile(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
